import React, { useState } from "react";
import { BirthdayAssortWithSteps } from "../../../models/BirthDaysModels/BirthdayAssortWithSteps";
import { Alert, Grid } from "@mui/material";
import getId from "../../../../utils/getId";
import { useTranslation } from "react-i18next";

interface IProps {
  assorts: BirthdayAssortWithSteps[];
  selectedAssort: BirthdayAssortWithSteps;
  onSelectAssort: (value: BirthdayAssortWithSteps) => void;
  handleStep: (step: number) => void;
}

const FirstStep: React.FC<IProps> = ({ assorts, selectedAssort, onSelectAssort, handleStep }: IProps) => {
  const { t } = useTranslation();
  const [mainAssort, setMainAssort] = useState(99);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} style={{ marginBottom: "10px" }}>
        <div className="alert alert-yellow alert-big alert-thin" style={{ marginBottom: "16px" }}>
          {t("ze_wzgledu_na_duze_zainteresowanie_wprowadzilismy_system_do_samodzielnego_skladania_rezerwacji")}
        </div>
      </Grid>
      {assorts?.map((item: BirthdayAssortWithSteps, index: number) => (
        <Grid key={index} item xs={3}>
          <div className={`first-step-assort ${mainAssort === index ? "first-step-assort-main" : ""}`}>
            {/* <div className="img" style={{ backgroundImage: `url(${item.picture})` }}></div> */}
            <div className="text">
              <h3>{item.name}</h3>

              <p className="text-description" dangerouslySetInnerHTML={{ __html: item.description }}></p>
            </div>

            <button
              className={`button medium padding-medium ${
                mainAssort === index
                  ? "button big padding-medium button-fill-main-contrast"
                  : "button big padding-medium button-fill-gray"
              }`}
              onClick={() => {
                onSelectAssort(item);
                setMainAssort(index);
                handleStep(2);
              }}
            >
              {mainAssort === index ? t("wybrano") : t("wybierz")}
            </button>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

export default FirstStep;
